import { render, staticRenderFns } from "./DrawerColor.vue?vue&type=template&id=1895a896&"
import script from "./DrawerColor.vue?vue&type=script&lang=js&"
export * from "./DrawerColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports